(function(){

var SIDEBAR_TOGGLE_SPEED;

SIDEBAR_TOGGLE_SPEED = 200;

angular.module('mainNavigation', [
    'theme',
    'ui.bootstrap',
    'smg.ui',
    'smg.ui.animation',
    'angularMoment', // For chat...
    'jQuery',
    'laravel'
])

.service('sidebar', [
    '$window', '$timeout',
    function ($window, $timeout) {
        //get current state
        this.show = true;
        var setting;
        if(localStorage)
        {
            setting =  localStorage.getItem('sidebar_setting');
        }
        else {
            setting =  $.cookie('sidebar_setting');
        }
        if(setting!==undefined && setting!==null){
            setting = JSON.parse(setting);
            this.show = setting.show;
        }
        this.current = {
            page: null,
            category: null,
            route: null
        };
        this.active = {
            page: null,
            category: null,
            route: null
        };

        this.toggle = function () {
            this.show = !this.show;
            if(localStorage){
                localStorage.setItem('sidebar_setting',JSON.stringify( {'show':this.show} ));
            }
            else
            {
                $.cookie('sidebar_setting', JSON.stringify( {'show':this.show} ),{ path: '/'});//set cookie as global cookie
            }
            $timeout(function() {
                angular.element($window).trigger('resize');
            }, SIDEBAR_TOGGLE_SPEED);
        };

        this.isActive = function (menuItem) {
            if (menuItem == null) { return false; }

            if (menuItem.kind === 'page') {
                return this.active.page === menuItem;
            }

            if (menuItem.kind === 'category') {
                return this.active.category === menuItem && !menuItem.hide;
            }

            return false;
        };

        this.isCurrent = function (menuItem) {
            if (menuItem == null) { return false; }

            if (menuItem.kind === 'page') {
                return this.current.page === menuItem;
            }

            if (menuItem.kind === 'category') {
                return this.current.category === menuItem;
            }

            return false;
        };

        this.makeActive = function (menuItem) {
            if (menuItem != null) {
                if (menuItem.kind === 'page') {
                    // This is a page, make it current (until the page reloads)
                    this.current.page = menuItem;
                    this.active.page = menuItem;
                } else if (menuItem.kind === 'category') {
                    if (this.active.category === menuItem) {
                        // Toggle hide/show
                        menuItem.hide = !menuItem.hide;
                    } else {
                        // Making active from another item,
                        // discard any previous hide value
                        menuItem.hide = false;
                        this.active.page = null;
                        this.active.category = menuItem;
                    }
                }
            }
        };
    }
])

.service('rightSidebar', [
    '$http', 'laroute', 'jQuery', '$window', '$timeout',
    function ($http, laroute, jQuery, $window, $timeout) {
        this.toggle = function () {
            this.show = !this.show;

            $timeout(function() {
                angular.element($window).trigger('resize');
            }, SIDEBAR_TOGGLE_SPEED);

            if (this.show) {
                this.unreadCount = 0;
            }

            // Update the chat widget setting
            $http({
                method: 'GET',
                url: laroute.route('ajax.feed-timestamp-refresh'),
                params: {
                    panelShown: this.show
                }
            }).catch(function () {
                jQuery.jGrowl('There was an error updating your feed', {
                    theme: 'growl-error'
                });
            });
        };
    }
])

.directive('smgNavigation', [
    'sidebar', 'theme',
    function (sidebar, theme) {
        return {
            restrict: 'A',
            controller: 'mainNavigationController',
            link: function (scope, element, attrs) {
                var menuData, route, page, category;

                scope.theme = theme;
                scope.sidebar = sidebar;

                // Load data into the scope from data attributes
                menuData = angular.fromJson(attrs.smgNavigation);
                if (!angular.isArray(menuData)) {
                    menuData = [];
                }
                scope.menuData = menuData;
                route = attrs.smgCurrentRoute;
                sidebar.current.route = route;
                page = scope.findItemForRoute(route, 'page');
                if (page != null) {
                    sidebar.current.page = page;
                    category = scope.findCategoryForPage(page);
                } else {
                    category = scope.findItemForRoute(route, 'category');
                }
                if (category != null) {
                    sidebar.current.category = category;
                }
                scope.contextIdString = attrs.smgContextId;
            }
        };
    }
])

.controller('mainNavigationController', [
    '$scope', 'sidebar', 'laroute',
    function ($scope, sidebar, laroute) {
        $scope.lengthy = 28;
        $scope.sidebar = sidebar;
        $scope.isParent = document.getElementById('isParent').value;

        // Change on context select (but only when changed to a new value)
        $scope.$watch('contextId', function (contextId, oldContextId) {
            if (oldContextId != null && contextId !== oldContextId) {
                window.location = laroute.route('user.manageaction', {
                    context: $scope.isParent == 1 ? 'parent' : contextId > 0 ? 'team' : 'self',
                    'id': contextId
                });
            }
        });

        $scope.$watch('contextIdString', function (contextId) {
            if (contextId === '') {
                contextId = 0;
            } else {
                contextId = parseInt(contextId);
            }
            if ((contextId > 0) !== true) {
                contextId = 0;
            }

            if ($scope.contextId !== contextId) {
                $scope.contextId = contextId;
            }
        });

        // Find the menu item matching the provided route (direct or indirect)
        $scope.findItemForRoute = function (route, kind) {
            var menuData, i, j, k, l, len, len1, len2, len3, menuItem,
                linkedRoute, subMenuItem;

            menuData = $scope.menuData;
            if (route == null || !angular.isArray(menuData)) { return null; }

            for (i = 0, len = menuData.length; i < len; i++) {
                menuItem = menuData[i];

                if (route === menuItem.route && menuItem.kind === kind) {
                    return menuItem;
                }

                if (menuItem.linked_routes != null) {
                    for (j = 0, len1 = menuItem.linked_routes.length; j < len1; j++) {
                        linkedRoute = menuItem.linked_routes[j];

                        if (route === linkedRoute && menuItem.kind === kind) {
                            return menuItem;
                        }
                    }
                }

                if (menuItem.items != null) {
                    for (k = 0, len2 = menuItem.items.length; k < len2; k++) {
                        subMenuItem = menuItem.items[k];

                        if (route === subMenuItem.route && subMenuItem.kind === kind) {
                            return subMenuItem;
                        }

                        if (subMenuItem.linked_routes != null) {
                            for (l = 0, len3 = subMenuItem.linked_routes.length; l < len3; l++) {
                                linkedRoute = subMenuItem.linked_routes[l];
                                if (route === linkedRoute && subMenuItem.kind === kind) {
                                    return subMenuItem;
                                }
                            }
                        }
                    }
                }
            }

            return null;
        };

        $scope.findCategoryForPage = function (page) {
            var menuData, i, len, menuItem;

            menuData = $scope.menuData;
            if (page == null || !angular.isArray(menuData)) { return null; }

            for (i = 0, len = menuData.length; i < len; i++) {
                menuItem = menuData[i];

                if (
                    menuItem.kind === 'category' &&
                    menuItem.items != null &&
                    menuItem.items.indexOf(page) !== -1
                ) {
                    return menuItem;
                }
            }

            return null;
        };

        // Change current route based on current item (and active item if null)
        $scope.$watch('sidebar.current.page', function (menuItem) {
            if (menuItem == null) { return; }

            if (menuItem.route != null) {
                // Change the route to this item's default route
                sidebar.current.route = menuItem.route;
            }

            // Set active page if not yet set
            if (sidebar.active.page == null) {
                sidebar.active.page = menuItem;
            }
        });

        // Change current route based on current item (and active item if null)
        $scope.$watch('sidebar.current.category', function (menuItem) {
            // Set active category if not yet set
            if (sidebar.active.category == null) {
                sidebar.active.category = menuItem;
            }
        });

        // Set active route to current route if not yet set
        $scope.$watch('sidebar.current.route', function (currentRoute) {
            if (currentRoute == null) { return; }

            if (sidebar.active.route == null) {
                sidebar.active.route = currentRoute;
            }
        });

        // Change active route based on active page
        $scope.$watch('sidebar.active.page', function (menuItem) {
            if (menuItem == null) { return; }

            if (menuItem.route != null) {
                sidebar.active.route = menuItem.route;
            } else if (!menuItem.individual) {
                sidebar.active.route = null;
            }
        });

        $scope.linkTo = function (menuItem) {
            if (
                menuItem != null &&
                menuItem.kind !== 'category' &&
                menuItem.route != null &&
                menuItem.route !== '#' &&
                menuItem.route !== ''
            ) {
                if(menuItem.route.indexOf('/',0)  >= 0 )
                {
                    return menuItem.route
                }
                return laroute.route(menuItem.route);
            } else {
                return null;
            }
        };
        
    }
])

.animation('.menu-item-items', [
    'jQuery',
    function (jQuery) {
        return {
            addClass: function (element, className, doneFn) {
                if (className === 'ng-hide') {
                    jQuery(element).slideUp(250, doneFn);
                } else {
                    doneFn();
                }
            },
            removeClass: function (element, className, doneFn) {
                if (className === 'ng-hide') {
                    jQuery(element).hide().slideDown(250, doneFn);
                } else {
                    doneFn();
                }
            }
        };
    }
])

.directive('smgIndividualItem', [
    'sidebar', 'jQuery',
    function (sidebar, jQuery) {
        return {
            scope: true,
            link: function (scope, element, attrs) {
                var menuItem;

                scope.sidebar = sidebar;

                // Setup object for individual menu item
                menuItem = {
                    individual: true,
                    key: attrs.smgIndividualItem
                };

                // Set this invididual item's menu item scope variable
                scope.individualItem = menuItem;

                // Detect kind from class
                if (element.hasClass('menu-item-category')) {
                    menuItem.kind = 'category';
                } else if (element.hasClass('menu-item-page')) {
                    menuItem.kind = 'page';
                }

                // Link the click event (jQuery usage)
                element.find('.menu-item-link:first').on('click', function () {
                    scope.$apply(function () {
                        scope.sidebar.makeActive(menuItem);
                    });
                });

                // Update classes when the active item changes
                if (menuItem.kind === 'page') {
                    scope.$watch('sidebar.active.page', function (activeItem) {
                        element.toggleClass('active', sidebar.isActive(menuItem));
                    });

                    // Update class when (if?) the current item changes
                    scope.$watch('sidebar.current.page', function (currentItem) {
                        element.toggleClass('current', currentItem === menuItem);
                    });
                } else if (menuItem.kind === 'category') {
                    scope.$watch('sidebar.active.category', function (activeItem) {
                        element.toggleClass('active', sidebar.isActive(menuItem));
                    });

                    // Update the class when a category is toggled
                    scope.$watch('individualItem.hide', function () {
                        element.toggleClass('active', sidebar.isActive(menuItem));
                    });
                }

                // This individual item is the current route, according to the blade
                if (attrs.smgIndividualItemCurrent != null) {
                    // Since either a page/category) might both try to
                    // be current, set active/current per menuItem.kind
                    if (sidebar.current[menuItem.kind] == null || menuItem.kind === 'page') {
                        sidebar.active[menuItem.kind] = menuItem;
                        sidebar.current[menuItem.kind] = menuItem;
                    }
                }
            }
        };
    }
])

.controller('navbarController', [
    '$scope', 'sidebar', 'rightSidebar', 'theme', '$animate', '$timeout',
    'jQuery',
    function ($scope, sidebar, rightSidebar, theme, $animate, $timeout,
        jQuery
    ) {
        var windowResize;

        $scope.theme = theme;
        $scope.sidebar = sidebar;
        $scope.rightSidebar = rightSidebar;

        // Call window resize events, for Highcharts and other JS rendering
        windowResize = function () {
            var windowElement;

            windowElement = angular.element(window);
            windowElement.resize();
            $timeout(function () {
                windowElement.resize();
            }, SIDEBAR_TOGGLE_SPEED, false);
        };

        angular.element(document).ready(function () {
            var is_iPad = navigator.userAgent.match(/iPad/i) != null;

            if(is_iPad) {
                $scope.sidebar.show = true;
            }
            if ($scope.sidebar.show === false) {
                $animate.addClass(
                    angular.element('body'),
                    'sidebar-narrow'
                );
            } else if ($scope.sidebar.show === true) {
                $animate.removeClass(
                    angular.element('body'),
                    'sidebar-narrow'
                );
            }
        });

        $scope.$watch('sidebar.show', function (sidebarShow) {
            var promise;
            if (sidebarShow) {
                promise = $animate.removeClass(
                    angular.element('body'),
                    'sidebar-narrow'
                );
            } else {
                promise = $animate.addClass(
                    angular.element('body'),
                    'sidebar-narrow'
                );
            }
            promise.then(windowResize);
        });

        $scope.$watch('rightSidebar.show', function (rightSidebarShow) {
            var pageContent, finishAnimating, promise;

            pageContent = angular.element('.page-content');
            finishAnimating = function () {
                pageContent.removeClass('animating');
                windowResize();
            };

            if (rightSidebarShow) {
                pageContent.addClass('animating');
                promise = $animate.addClass(
                    angular.element('body'),
                    'show-right-sidebar'
                );
                angular.element(document).trigger('show-right-sidebar');
            } else {
                pageContent.addClass('animating');
                promise = $animate.removeClass(
                    angular.element('body'),
                    'show-right-sidebar'
                );
            }
            promise.then(finishAnimating);
        });
    }
])

.controller('rightSidebarController', [
    '$scope', 'rightSidebar',
    function ($scope, rightSidebar) {
        $scope.rightSidebar = rightSidebar;
    }
])

.directive('smgTitleIfLengthy', [function () {
    return {
        restrict: 'AC',
        link: function (scope, element, attrs) {
            if (angular.isUndefined(attrs.ngBind)) {
                return;
            }

            scope.$watch(attrs.ngBind, function (newValue, oldValue) {
                var lengthy;

                lengthy = attrs.smgTitleIfLengthy || scope.lengthy;

                if (
                    lengthy != null &&
                    newValue != null &&
                    newValue.length > lengthy
                ) {
                    element.attr('title', newValue);
                } else if (element.attr('title') === oldValue) {
                    element.removeAttr('title');
                }
            });
        }
    };
}])


.directive('smgUserMenu', [
    'theme', '$uibModal',
    function(theme, $uibModal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.theme = theme;

                if (theme === 'sportsmed') {
                    // Do nothing for this theme
                    scope.openUserMenu = angular.noop;
                    return;
                }

                scope.user = angular.fromJson(attrs.smgUserMenu);

                // User menu modal
                scope.openUserMenu = function() {
                    $uibModal.open({
                        scope: scope,
                        animation: true,
                        backdrop: 'static',
                        templateUrl: 'userMenuModal',
                        backdropClass: 'modal-backdrop-glass',
                        windowClass: 'modal-glass'
                    });
                };
            }
        };
    }
])

.directive('commentStreamWidget', [
    'rightSidebar',
    function (rightSidebar) {
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                rightSidebar.show = attrs.showChat === 'true';
                rightSidebar.unreadCount = parseInt(attrs.unreadCount) || 0;
            }
        };
    }
])

;

}).call(this);
